import FundamentalSubNavigation from './FundamentalSubNavigation';
import { isDesktop, getPosition } from '../../utils';
import { HEADER_UP } from '../../constants';

class ModelSubNavigation extends FundamentalSubNavigation {
  constructor(el) {
    super(el);
    this.positionFlag = 0;
    this.init();
  }

  init() {
    super.init();
    this.addListeners();
  }

  addListeners() {
    super.addListeners();
    window.scrollAgent.scrollEvent((_args) => {
      this.pinSubNav();
    });
    $(window).on('scroll', () => {
      if (!isDesktop()) {
        this.customScrollTop = $(window).scrollTop();
        this.pinSubNav();
      }
    });
  }

  pinSubNavAction() {
    this.dom.$header.after(this.dom.$subNav);
    this.$el.css('height', this.dom.$subNav.outerHeight());
    this.dom.$subNav.addClass(this.classes.pinSubNav);
    this.navIsPinned = true;
  }

  unPinSubNavAction() {
    // remove class to subnav & other styles when unpin
    this.$el.append(this.dom.$subNav).css('height', '');
    this.dom.$subNav.removeClass(this.classes.pinSubNav);
    this.navIsPinned = false;
  }

  pinSubNav() {
    const elOffsetTop = getPosition(this.$el.get(0)).y;
    if (isDesktop()) {
      const customSpace = this.headerDirection === HEADER_UP || this.customScrollTop === 0 ? 0 : this.dom.$header.outerHeight();
      if (this.customScrollTop + Math.max(customSpace, 0) > elOffsetTop) {
        // pin subnav to top at here
        if (!this.navIsPinned) {
          this.pinSubNavAction();
        }
        // turn back groupBottom to original position
        this.resetUnpinGroupBottomAboveFooterMobile();
      } else if (this.navIsPinned) {
        this.unPinSubNavAction();
      } else {
        // do nothing
      }
    } else {
      // move groupBottom to above footer
      this.unpinGroupBottomAboveFooterMobile();
    }
  }

  /*  */
  moveDOMSubNavToUnderHeader() {
    this.dom.$header.after(this.dom.$groupContentTop);
    this.dom.$header.after(this.dom.$groupContentBottom);
  }

  returnDOMSubNavToOriginalPosition() {
    this.dom.$groupContentBottomParent.after(this.dom.$groupContentTop);
    this.dom.$groupContentBottomParent.after(this.dom.$groupContentBottom);
  }
}
export default ModelSubNavigation;